import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../../common/Card';
import { extractNumericId } from '../../../utils/formatters';
import './styles.css';

function RepairCard({
  repair,
  formatDate = (date) => date,
  className = ''
}) {
  if (!repair) return null;

  // 解析富文本格式JSON
  const parseRichText = (text) => {
    if (!text) return '暫無信息';
    
    try {
      // 嘗試解析JSON
      const richText = JSON.parse(text);
      
      // 檢查是否是富文本格式
      if (richText && richText.type === 'root' && richText.children && richText.children.length > 0) {
        // 提取文本內容
        let extractedText = '';
        const extractText = (nodes) => {
          if (!nodes || !nodes.length) return;
          
          nodes.forEach(node => {
            if (node.type === 'text' && node.value) {
              extractedText += node.value;
            }
            if (node.children) {
              extractText(node.children);
            }
          });
        };
        
        extractText(richText.children);
        return extractedText || '暫無信息';
      }
      
      // 如果不是富文本格式，直接返回原始字符串
      return text;
    } catch (e) {
      // 如果解析失敗，直接返回原始字符串
      return text;
    }
  };

  // 狀態映射
  const statusMap = {
    'Pending': '待處理',
    'In Progress': '處理中',
    'Completed': '已完成',
    'Cancelled': '已取消'
  };

  // 根據狀態獲取CSS類名
  const getStatusClass = (status) => {
    switch (status) {
      case 'Pending':
        return 'status-pending';
      case 'In Progress':
        return 'status-in-progress';
      case 'Completed':
        return 'status-completed';
      case 'Cancelled':
        return 'status-cancelled';
      default:
        return 'status-pending';
    }
  };

  return (
    <Card className={`repair-card ${className}`}>
      <div className="repair-card-header">
        <span className={`repair-status ${getStatusClass(repair.status)}`}>
          {statusMap[repair.status] || repair.status}
        </span>
        <Link to={`/repairs/${extractNumericId(repair.id)}`} className="repair-card-link">
          查看詳情
        </Link>
      </div>

      <div className="repair-card-content">
        <div className="repair-card-info">
          <p><strong>技術員:</strong> {repair.technician || '未指派'}</p>
          <p><strong>創建日期:</strong> {formatDate(repair.creation_date)}</p>
          {repair.repair_cost && <p><strong>維修費用:</strong> {repair.repair_cost}</p>}
          
          {repair.status === 'Completed' && repair.completion_date && (
            <p><strong>完成日期:</strong> {formatDate(repair.completion_date)}</p>
          )}
        </div>

        {repair.initial_diagnosis && (
          <div className="repair-card-diagnosis">
            <p><strong>初步診斷:</strong></p>
            <p className="repair-diagnosis-text">{parseRichText(repair.initial_diagnosis)}</p>
          </div>
        )}
      </div>
    </Card>
  );
}

export default RepairCard; 